import { render, staticRenderFns } from "./v-feedback.vue?vue&type=template&id=78713c64&scoped=true&"
import script from "./v-feedback.vue?vue&type=script&lang=js&"
export * from "./v-feedback.vue?vue&type=script&lang=js&"
import style0 from "./v-feedback.vue?vue&type=style&index=0&id=78713c64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78713c64",
  null
  
)

export default component.exports